import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import { YearChoices } from '../../core/enums/year-choices.enum';
import { YearSelectionComponent } from '../year-selection/year-selection.component';
import * as moment from 'moment';
import { BehaviorSubject } from 'rxjs';
import { DateRange } from '../../core/models/date-range';
import { TextKeys } from '../../core/i18n/text-keys';
import {TIMEZONE} from '../../core/services/language.service';

@Component({
  selector: 'app-year-and-quartal-selection',
  templateUrl: './year-and-quartal-selection.component.html',
  styleUrls: ['./year-and-quartal-selection.component.scss'],
})
export class YearAndQuartalSelectionComponent implements OnInit {
  @ViewChild('yearSelection') yearSelectionElement: YearSelectionComponent;
  @Input() defaultDate: DateRange;
  @Input() isQuartalSelectionEnabled = true;
  @Output() dateRangeChanged = new EventEmitter<DateRange>();

  texts = TextKeys;
  selectedYearInfo = YearChoices.full;
  choices = YearChoices;
  radioDisabled$ = new BehaviorSubject(false);

  constructor() {}

  ngOnInit() {
  }

  onYearChanged(event: string) {
    this.dateRangeChanged.emit(this.getDateRange());
  }

  onRadioChange(){
    this.dateRangeChanged.emit(this.getDateRange());
  }

  getDateRange(): DateRange {
    const year = this.yearSelectionElement.getYear();
    let start: string;
    let end: string;

    if (this.selectedYearInfo === YearChoices.full) {
      start = moment.tz(moment(), TIMEZONE).year(Number(year)).startOf('year').format();
      end = moment.tz(moment(), TIMEZONE).year(Number(year)).endOf('year').format();
    } else {
      start = moment.tz(moment(), TIMEZONE)
        .year(Number(year))
        .quarter(this.selectedYearInfo)
        .startOf('quarter')
        .format();
      end = moment.tz(moment(), TIMEZONE)
        .year(Number(year))
        .quarter(this.selectedYearInfo)
        .endOf('quarter')
        .format();
    }
    return {
      start,
      end,
    } as DateRange;
  }

  getYear(): string {
    return this.yearSelectionElement.getYear();
  }

  stop(event: Event, item: YearChoices) {
    this.selectedYearInfo = item;
    event.stopPropagation();
  }

  disableRadio() {
    this.selectedYearInfo = YearChoices.full;
    this.radioDisabled$.next(true);
  }

  disable() {
    this.radioDisabled$.next(true);
    this.yearSelectionElement.disable();
  }

  enable() {
    this.yearSelectionElement.enable();
    this.radioDisabled$.next(false);
  }
}
